export default __webpack_public_path__ + "static/media/wij_kopen_vastgoed.413bf449.svg";